import { Device } from '@cardsjd/device';

export default class Prompter {
	constructor(options) {
		this.onPrompt = function (_message, _os) { };

		this.appName = options?.appName || 'The Game';
		this.message1 = options?.promptMessage1 || 'Having fun?';
		this.message2 = options?.promptMessage2 || 'It looks like you really like %@?';
		this.message3 = options?.promptMessage3 || 'Are you addicted to %@?';
		this.message4 = options?.promptMessage4 || 'You have played a zillion times. Do you like %@ yet?';
		this.message5 = options?.promptMessage5 || 'You have played 300 zillion times. Do you like %@ yet?';
		//localStorage key needs to be set before load
		this.localStorageKey = (this.appName.toLowerCase().replace(/\s/g, '') || '') + '.delayedPromptCount';

		this.openCount = options?.openCount || this.load();
	}

	StorageAvailable(type) {
		try {
			const storage = window[type],
				x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return false;
		}
	}

	load() {
		let openCount = 0;

		if (this.StorageAvailable('localStorage')) {
			openCount = localStorage.getItem(this.localStorageKey) || 0;
			openCount = Number(openCount) || 0;
		}

		return openCount;
	}

	save(openCount) {
		if (this.StorageAvailable('localStorage')) {
			localStorage[this.localStorageKey] = openCount;
		}
	}

	delayedPrompt(openCount) {
		if (!openCount) {
			openCount = (this.openCount + 1) || 1;
		}

		let message = null;

		if (openCount == 10) {
			message = 'Having fun?';
		}

		if (openCount == 25) {
			message = 'It looks like you really like %@?';
		}

		if (openCount == 60) {
			message = 'Are you addicted to %@?';
		}

		if (openCount == 200) {
			message = 'You have played a zillion times. Do you like %@ yet?';
		}

		if (openCount == 300) {
			message = 'You have played 300 zillion times. Do you like %@ yet?';
		}

		this.openCount = openCount;
		this.save(this.openCount);

		if (message) {
			message = message.replace('%@', this.appName);

			if (this.onPrompt) {
				const os = this.getPlatform();
				this.onPrompt(message, os);
			}
		}
	}
	getPlatform() {
		const device = new Device();
		return device.getPlatform();
	}
}
